import { render } from "./delete-video-modal.vue?vue&type=template&id=3fc012d6"
import script from "./delete-video-modal.vue?vue&type=script&lang=js"
export * from "./delete-video-modal.vue?vue&type=script&lang=js"
script.render = render

export default script